export const REQUEST_REGULAR_LOGIN = "REQUEST_REGULAR_LOGIN";
export const GRANT_REGULAR_LOGIN = "GRANT_REGULAR_LOGIN";
export const REVOKE_REGULAR_LOGIN = "REVOKE_REGULAR_LOGIN";
export const RESET_REGULAR_LOGIN = "RESET_REGULAR_LOGIN";

export const REQUEST_GOOGLE_LOGIN = "REQUEST_GOOGLE_LOGIN";
export const GRANT_GOOGLE_LOGIN = "GRANT_GOOGLE_LOGIN";
export const REVOKE_GOOGLE_LOGIN = "REVOKE_GOOGLE_LOGIN";
export const RESET_GOOGLE_LOGIN = "RESET_GOOGLE_LOGIN";
